// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"6b3215da","247":"b66236eb","284":"3924cda8","422":"b639f65a","627":"25e53223","867":"e397b0f9","923":"2edf3114","938":"309b171b"}[chunkId] + ".chunk.js";
};